module.exports = __webpack_public_path__ + "img/derby-college.9cb2b4cf.png";